var path = '/var/www/mmscny-cms/src/app/components/menu-list/menu-list.html';
var html = "<feature-main-page-template details=$ctrl.details slug-url={{$ctrl.slugUrl}} menu-name={{$ctrl.menuName}} menu-id={{$ctrl.menuId}} on-edit-overview=$ctrl.onEditOverview() on-edit-sequence=$ctrl.onEditSequence() on-publish-status=$ctrl.onPublishStatus()> </feature-main-page-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/menu-list/menu-list.html
// module id = 775
// module chunks = 0